import { type MeDto, MODULES } from '@bqcrm/shared';
import { Button } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { canModule } from '../auth';
import { EmptyState } from './ui';

/** Strona modułu lewego menu — bez uprawnienia `modul.<kod>` zamiast niej komunikat (adres wpisany ręcznie, stara zakładka). */
export function ModuleGate({ me, module, children }: { me: MeDto; module: string; children: ReactNode }) {
  if (canModule(me, module)) return children;
  const label = MODULES.find((m) => m.code === module)?.label ?? module;
  return (
    <EmptyState
      icon={<IconLock size={24} />}
      title={`Brak dostępu do modułu „${label}”`}
      hint="Twoje role nie obejmują tego modułu. Jeśli potrzebujesz do niego dostępu, poproś administratora o nadanie prawa."
      action={
        <Button component={Link} to="/" mt="xs">
          Wróć na pulpit
        </Button>
      }
    />
  );
}
